import { IAlertModalType } from "src/app/interfaces/components/alert-modal.interface";

export const alertConfig: Record<IAlertModalType, {
  title: string;
  defaultMessage: string;
}> = {
  success: {
    title: 'ALERT_MODAL.TITLE_SUCCESS',
    defaultMessage: 'ALERT_MODAL.DEFAULT_MESSAGE_SUCCESS'
  },
  error: {
    title: 'ALERT_MODAL.TITLE_ERROR',
    defaultMessage: 'ALERT_MODAL.DEFAULT_MESSAGE_ERROR'
  },
  alert: {
    title: 'ALERT_MODAL.TITLE_ALERT',
    defaultMessage: 'ALERT_MODAL.DEFAULT_MESSAGE_ALERT'
  }
};
